var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVerifiedBadge = function SvgIconVerifiedBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    fillRule: "evenodd",
    d: "M15.597 9.928Q16 9.215 16 8.375q0-.891-.447-1.638a2.75 2.75 0 0 0-1.197-1.096q.178-.482.178-1.072.002-1.265-.847-2.16-.848-.894-2.043-.893-.538 0-1.019.196A3.1 3.1 0 0 0 9.544.472 2.73 2.73 0 0 0 8 0q-.84.001-1.544.475a3.1 3.1 0 0 0-1.081 1.24 2.7 2.7 0 0 0-1.019-.196q-1.195.002-2.053.894-.857.891-.856 2.159 0 .535.197 1.072Q.894 6 .447 6.74A3.1 3.1 0 0 0 0 8.375q0 .84.4 1.553.403.713 1.081 1.106-.034.254-.034.394-.001 1.267.856 2.16.858.894 2.053.893.538 0 1.019-.197.374.787 1.072 1.25Q7.14 16.002 8 16q.84.002 1.544-.475a3.1 3.1 0 0 0 1.081-1.24q.483.196 1.019.196 1.196 0 2.043-.893.846-.89.847-2.16 0-.268-.018-.394.679-.39 1.08-1.106",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.102 5.2a.733.733 0 0 1 .017 1.01l-4.256 4.571a.68.68 0 0 1-.496.219.68.68 0 0 1-.497-.219l-2.364-2.54a.73.73 0 0 1 .017-1.01.673.673 0 0 1 .976.02l1.868 2.006 3.76-4.039a.673.673 0 0 1 .975-.018",
    clipRule: "evenodd"
  })));
};
export default SvgIconVerifiedBadge;